// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__l6kDv","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2gt4E"};